import React from "react";
import { CTAButton } from "../CTAButton";
import { images } from "../../data/links";
export function AuthorSection() {
  return <section className="bg-paper px-4 py-16 sm:py-24" data-id="element-66" data-mp="3m6pgk6gn0lqj">
      <div className="mx-auto grid max-w-6xl items-center gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:gap-14" data-id="element-67" data-mp="3qza4wsgry6mo">
        <div className="relative mx-auto w-full max-w-md" data-id="element-68" data-mp="3vyms5ebk5fps">
          <img src={images.author} alt="Dr. Nathan Brooks in his dental clinic" className="w-full rounded-[28px] object-cover shadow-xl" data-id="element-69" data-mp="3w068t614lss3" />
          <div className="absolute inset-x-4 bottom-4 rounded-2xl bg-navy/95 p-4 text-center" data-id="element-70" data-mp="339ob6kj68jm2">
            <p className="font-display text-xl font-extrabold text-white" data-id="element-71" data-mp="386xzfwutqp8b">Dr. Nathan Brooks</p>
            <p className="text-sm font-semibold text-brand" data-id="element-72" data-mp="3d96qgno4zh7s">Creator of The ClinCheck Blueprint™</p>
          </div>
        </div>

        <div data-id="element-73" data-mp="nkmk8kbegyjd">
          <p className="text-sm font-extrabold uppercase text-[#0A7FBF]" data-id="element-74" data-mp="sh4n1en66mt2">About the author</p>
          <h2 className="mt-3 text-balance font-display text-[30px] font-extrabold leading-tight text-navy sm:text-5xl" data-id="element-75" data-mp="2484puxhvyhgp">
            Why I created The ClinCheck Blueprint™
          </h2>
          <div className="mt-6 space-y-4 text-[17px] leading-relaxed text-navy/80" data-id="element-76" data-mp="1z77bkvzzy7kh">
            <p data-id="element-77" data-mp="1v5lt8v4p112w">
              I've always believed that clear aligner treatment planning requires more than knowing how to navigate digital
              software. It requires a structured way to evaluate the available information, understand the proposed
              movements, identify potential limitations, and determine which questions deserve further attention.
            </p>
            <p data-id="element-78" data-mp="1bjz3y7f3imfa">
              Clinical knowledge is often spread across educational materials, personal notes, professional discussions, and
              individual experience. That makes it harder to establish a repeatable workflow.
            </p>
            <p data-id="element-79" data-mp="xjy7d45v615m">
              So I organized the material around six practical areas of clear aligner planning — visual frameworks, review
              worksheets, and documentation tools in one digital resource.{" "}
              <strong className="text-navy" data-id="element-80" data-mp="svf5h7qdy7ya">Something you could consult while working</strong>, not another lengthy course
              that remains unopened after the first week.
            </p>
            <p className="font-semibold text-navy" data-id="element-81" data-mp="iw6782ohm764">
              I believe a structured process can make complex work easier to organize. And that's exactly what I want The
              ClinCheck Blueprint to help you do.
            </p>
          </div>
          <p className="mt-6 font-display text-2xl font-extrabold italic text-navy" data-id="element-82" data-mp="1bnhh24o66y1o">— Dr. Nathan Brooks</p>

          <div className="mt-8" data-id="element-83" data-mp="wuwbq3dmz94i">
            <CTAButton label="I want Dr. Brooks' system" className="lg:mx-0" data-id="element-84" data-mp="11v1xj2x861eo" />
          </div>
        </div>
      </div>
    </section>;
}